import createEmotion, { Emotion } from 'create-emotion';

const KEY = 'editor';

const emotionByDocument = new WeakMap<Document, Emotion>();

export function getEmotion(document: Document) {
  let emotion = emotionByDocument.get(document);

  if (!emotion) {
    emotion = createEmotion({
      key: KEY,
      container: document.head,
    });
    emotionByDocument.set(document, emotion);
  }

  return emotion;
}
